import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PriceService from "./../../../services/PriceService";
import Icon from "@mdi/react";
import { mdiLoading, mdiClose, } from "@mdi/js";

const plansData = [
  {
    id: 'basic',
    title: 'Basic',
    price: 0,
    currency: '€',
    engagement: 'Sans engagement',
    description: 'Commandez vos formulaires d’urbanisme en un clic.',
    features: [
      { "label": "Cadastre", "included": 1 },
      { "label": "Portail d’urbanisme", "included": 1 },
      { "label": "Achat de formulaires", "included": 1 },
    ],
    buttonText: "Continuer"
  },
  {
    id: 0, code: "Pro", "level": 'na', ref: "Professionnel", price: 49900, period: "mois", title: "PRO", subtitle: "Abonnement PRO", options: [{ val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: 4 }],

    currency: '€',
    engagement: 'Engagement 12 mois',
    description: 'Consultez toutes les informations publiques sur le portail d\'urbanisme.',
    features: [
      { "label": "Cadastre", "included": 1 },
      { "label": "Portail d’urbanisme", "included": 1 },
      { "label": "Mise à jour en continu", "included": 1 },
      { "label": "Contraintes relatives à la parcelle", "included": 1 },
      { "label": "Surfaces des contraintes %", "included": 1 },
      { "label": "Achat de formulaires", "included": 1 },
    ],
    buttonText: "Souscrire"
  },
  {
    id: 10, code: "Pro+", "level": 'na', ref: "Professionnel", price: 89900, period: "mois", title: "PRO+", subtitle: "Abonnement PRO+", options: [{ val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: 4 }],

    currency: '€',
    engagement: 'Engagement 12 mois',
    description: 'Explorez les opportunités foncières et éditez vos formulaires.',
    features: [
      { "label": "Cadastre", "included": 1 },
      { "label": "Portail d’urbanisme", "included": 1 },
      { "label": "Mise à jour en continu", "included": 1 },
      { "label": "Contraintes relatives à la parcelle", "included": 1 },
      { "label": "Surfaces des contraintes % et m2", "included": 1 },
      { "label": "Achat de formulaires", "included": 1 },
      { "label": "Réseaux Edf, Eaux", "included": 1 },
      { "label": "Prospection foncière urbaine", "included": 1 },
      { "label": "Recherche par propriétaire", "included": 1 },
    ],
    buttonText: "Souscrire"
  },
  {
    id: 11, code: "Solaire", "level": 'na', ref: "Solaire", price: 79900, period: "mois", title: "SOLAIRE", subtitle: "Abonnement Solaire", options: [{ val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: null }, { val: true, nb: 4 }],

    currency: '€',
    engagement: 'Engagement 12 mois',
    description: 'Localisez vos opportunités foncières photovoltaïques.',
    features: [
      { "label": "Cadastre", "included": 1 },
      { "label": "Portail d’urbanisme", "included": 1 },
      { "label": "Mise à jour en continu", "included": 1 },
      { "label": "Contraintes relatives à la parcelle", "included": 1 },
      { "label": "Surfaces des contraintes % et m2", "included": 1 },
      { "label": "Achat de formulaires", "included": 1 },
      { "label": "Réseaux Edf", "included": 1 },
      { "label": "Prospection foncière agricole", "included": 1 },
      { "label": "Recherche par propriétaire", "included": 1 },
      { "label": "Potentiel bâti photovoltaïque", "included": 1 },
    ],
    buttonText: "Souscrire"
  },
  /*{
  id: 'option',
  title: 'Option',
  price: '',
  currency: '',
  engagement: '',
  features: [
      'NRU - Note de renseignement d’urbanisme',
      'DPU - Droit de préemption',
      'ERP - Etat des risques naturels et de pollutions',
      'ERPS - Etat des risques du sous sol',
      'PAD - Plan d’aménagement de la Corse',
      'ENSA - Plan d’expositions aux bruits',
      'DUR - Document d’urbanisme',
      'Formulaires certifiés'
  ],
  buttonText: "Plus d’info"
  }*/
];

function PricingPlans({ setShowPricing }) {
  const priceService = new PriceService();
  const [selected, setSelected] = useState(null);
  const [codesTerr, setCodesTerr] = useState("");
  const [portailPrices, setPortailPrices] = useState(priceService.getPortailPrices());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (portailPrices.length > 0) {
      setSelected(portailPrices[0]);
    }
  }, [portailPrices]);

  const handleClick = async (item) => {
    setSelected(item);

    if (!item) {
      setError('Veuillez choisir un abonnement.');
      return;
    }

    if (item.price === 0) {
      setShowPricing(false);
      return;
    }

    if (!codesTerr) {
      setError('Veuillez choisir une EPCI.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Make a POST request to the backend to create a Checkout session
      const response = await axios.post('/Api/checkout/create-session', {
        subscription_type_id: item.id,
        codes_terr: codesTerr, // Send the selected codes_terr
      });

      const { url } = response.data;

      // Redirect to Stripe Checkout
      window.location.href = url;
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Une erreur s\'est produite.');
      setLoading(false);
    }
  };
  const handleClose = () => {
    setShowPricing(false)
  }

  return (
    <div className="container mb-5" style={{ opacity: 1 }}>
      <div className={"ue-pricing-close"}
        onClick={handleClose}
      >FERMER&nbsp;
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.2812 6.6L11.3433 9.449L8.40537 6.6L6.80597 8.151L9.74388 11L6.80597 13.849L8.40537 15.4L11.3433 12.551L14.2812 15.4L15.8806 13.849L12.9427 11L15.8806 8.151L14.2812 6.6ZM11.3433 0C5.07045 0 0 4.917 0 11C0 17.083 5.07045 22 11.3433 22C17.6161 22 22.6866 17.083 22.6866 11C22.6866 4.917 17.6161 0 11.3433 0ZM11.3433 19.8C6.3409 19.8 2.26866 15.851 2.26866 11C2.26866 6.149 6.3409 2.2 11.3433 2.2C16.3457 2.2 20.4179 6.149 20.4179 11C20.4179 15.851 16.3457 19.8 11.3433 19.8Z" fill="#9A9A9A" />
        </svg>
      </div>
      <div className="d-flex justify-content-center w-100 mb-1" style={{ height: "43px" }}>
        {error && <div className="alert alert-danger w-100" style={{ height: "40px" }}>{error}</div>} 
        {loading && <Icon className="mt-2" path={mdiLoading} size={1} spin />}
      </div>
      <h1 className="text-center">
        Choisissez votre territoire et abonnez-vous
      </h1>
      <div className="d-flex mb-1 flex-column justify-content-center align-items-center  w-100">
         <select
          className="form-control ue-portail-terr-price-item  ru-code"
          value={codesTerr}
          onChange={(e) => setCodesTerr(e.target.value)}
          style={{ height: "43px" }}
        >
          <option value="" disabled>
            Sélectionnez une EPCI
          </option>
          <option disabled>Corse-du-Sud</option>
          <option value="242010056">CA du Pays ajaccien</option>
          <option value="242000495">CC de l'Alta Rocca</option>
          <option value="242000503">CC du Celavu-Prunelli</option>
          <option value="200067049">CC de Spelunca-Liamone</option>
          <option value="200038958">CC de la Pieve de l'Ornano</option>
          <option value="242010130">CC Sartenais-Valinco</option>
          <option value="200040764">CC Sud Corse</option>
          <option disabled>Haute-Corse</option>
          <option value="242000354">CA de Bastia</option>
          <option value="242020105">CC de Calvi Balagne</option>
          <option value="200042943">CC du Cap Corse</option>
          <option value="200073252">CC Castagniccia-Casinca</option>
          <option value="242020071">CC du Centre Corse</option>
          <option value="200034205">CC de la Costa Verde</option>
          <option value="200033827">CC de Fium'orbu Castellu</option>
          <option value="200073104">CC de l'Île-Rousse - Balagne</option>
          <option value="200036499">CC de Marana-Golo</option>
          <option value="200073120">CC Nebbiu - Conca d'Oro</option>
          <option value="200015162">CC de l'Oriente</option>
          <option value="200073138">CC Pasquale Paoli</option>
        </select>
      </div>
      
      <div className="row mt-2 pt-2 justify-content-center">
        {plansData.map((plan) => (
          <div className="col-md-3 mb-4" key={plan.id} style={{ width: "10vw", minWidth: "211px", opacity: 1 }}>
            <div className="h-100" >
              <div className="card-body d-flex flex-column align-middle h-100" style={{ backgroundColor: "var(--theme-page-background)", borderRadius: "6px"}}>
                <div className="d-flex row ml-0" >
                  <div style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "6px",
                    width: "42px",
                    height: "42px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <img style={{ width: "42px", height: "31px" }} src="/img/eu_logo_v3_square.png" />

                  </div>
                  <div className="font-weight-bolder swal2-icon-font-size ml-2 my-2 align-middle">{plan.title}</div>
                </div>


                {plan.description && (
                  <span className="card-subtitle my-2" style={{ height: "40px" }}>
                    {plan.description}
                  </span>
                )}
                <div className="d-flex align-items-center mt-2 mb-2">
                  {plan.price ? (
                    <>
                    <span style={{ fontWeight: 700, fontSize: "20pt" }}>
                      <span className="CurrencyAmount">{plan.price / 100}&nbsp;{plan.currency}</span>
                    </span>
                      <span style={{ fontWeight: 300, fontSize: "10pt", marginLeft: "8px" }}>
                         HT<br />
                         par mois
                      </span>
                    </>
                  ) : (<span style={{ fontWeight: 700, fontSize: "20pt" }}>Gratuit</span>)
                  }
                </div>
                <button className="btn btn-primary mt-auto"
                  style={{ height: "35px" }}
                  onClick={() => handleClick(plan)}
                >
                  M'abonner
                </button>
                {plan.engagement && (
                  <p className="text-muted mt-1 mb-3">{plan.engagement}</p>
                )}
                <p className="mb-2" style={{color: "#ffffff"}} >Fonctionnalités :</p> 
                <ul className="list-unstyled flex-grow-1 ue-pricing-plan-list-item">
                  {plan.features.map((feature, index) => (
                    <li key={index}>
                      <i className={
                        feature['included'] === 1 ? ('fa-solid fa-circle text-primary')
                          : (feature['included'] === 2) ? ('fa-solid fa-circle text-warning')
                            : ('fa-solid fa-circle text-light')} ></i>
                      <span className="ue-pricing-plan-list-text" >{feature['label']}</span></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-center w-100" style={{ height: "43px" }}>

      </div>
      <div className="text-center mt-4">
        <p>Paiement sécurisé par Stripe</p>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg"
          alt="Stripe Logo"
          style={{ width: '80px', marginRight: '10px' }}
        />
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
          alt="Visa Logo"
          style={{ width: '60px', marginRight: '10px' }}
        />
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
          alt="MasterCard Logo"
          style={{ width: '40px' }}
        />
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    idUser: state.MeReducer.id,
    entity: state.MeReducer.entity,
  }
}

const mapDispatchTProps = dispatch => {
  return {
    setShowPricing: (e) => dispatch({ type: 'SET_SHOW_PRICING', data: e }),
  }
}


export default connect(mapStateToProps, mapDispatchTProps)(PricingPlans);
